/** Pass types where Google contactless mode is configured separately from Apple NFC. */
export const GOOGLE_CONTACTLESS_PASS_TYPES = [
  'loyalty',
  'storeCard',
  'stampCard',
];

/** Accepts both builder state types and API types, which spell loyalty differently. */
export const supportsGoogleContactlessMode = (
  passType?: string | null
): boolean => GOOGLE_CONTACTLESS_PASS_TYPES.includes(passType ?? '');

/** The API returns googleNfcEnabled as a boolean on some endpoints and an object on others. */
export const readGoogleNfcSetting = (
  value: boolean | { enabled?: boolean } | null | undefined
): boolean | undefined =>
  typeof value === 'boolean' ? value : (value?.enabled ?? undefined);

export const resolveGoogleNfcPreview = (
  passType: string,
  nfcEnabled: boolean,
  googleNfcEnabled?: boolean
): boolean =>
  supportsGoogleContactlessMode(passType)
    ? (googleNfcEnabled ?? nfcEnabled)
    : nfcEnabled;
